import React, { useContext, useState, useEffect, useRef } from 'react';
import { Button, makeStyles, TextField, Tooltip } from '@material-ui/core';
import { commonFilter, commonActionHeader } from '../../../constants/StyleConstants';
import SelectAcerBrag from '../../../components/SelectAcerBrag';
import ViewPortGridWrapper from '../../../containers/ViewPortGridWrapper';
import DefaultUnrederedGridMessage from '../../../containers/DefaultUnrenderedGridMessage';
import { Fragment } from 'react';
import SupplierFilter from '../../../components/SupplierFilter/SupplierFilter';
import { LoginContext } from '../../../contexts/LoginContext';
import DialogAcerBrag from '../../../components/UI/DialogAcerBrag';
import { defaultGridOptions, tooltipDelay, useGridColDefs } from '../../../utils/GridUtils';
import CheckCircleOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import PendingActionsIcon from "@mui/icons-material/PendingActionsOutlined";
import { AppContext } from '../../../contexts/AppContext';
import MaterialTable from 'material-table';
import { decodeFileXLSX } from '../../../utils/MiscellaneousUtils';
import { currentDateForFile } from '../../../utils/DateUtils';
import notificationsAPI from '../../../services/NotificationsApi';
import AnimatedButton from '../../../components/UI/AnimatedButton';
import FormatListNumberedOutlinedIcon from '@material-ui/icons/FormatListNumberedOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { centeredCell } from '../../../constants/StyleConstants';


const useStyles = makeStyles(theme => ({
  ...commonFilter,
  centeredCell,
  root: {
    marginTop: '3em',
  },
  gridActions: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    marginBottom: '1em',
  },
  gridControls: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  gridButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
  gridReference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    columnGap: '1em',
    fontSize: '.8em',
  },
  reference: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  leftSideButton: {
    borderRadius: '1em',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  rightSideButton: {
    borderRadius: '1em',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  activeGlow: {
    color: 'rgb(0, 255, 0)',
    boxShadow: '0px 0px 10px 0px rgb(0, 255, 0, .5)',
    borderRadius: '50%',
    margin: 0,
    stroke: 'rgb(0, 255, 0, .5)',
    strokeWidth: 4,
    strokeOpacity: 0.7,
  },
  hasNoComments: {
    color: '#BDBDBD',
  },
  sortButton: {
    '&.MuiButton-root': {
      minWidth: 'unset',
    },
    '&.MuiButton-startIcon': {
      margin: 0,
    },
  },
}));

const GridActions = ({
  selectedRows,
  setOpen,
  handleExport,
  loadingExport,
  sort,
  setSort,
  rows,
  notificationId,
  ...restProps
}) => {
  const classes = useStyles();
  const { isAllowedByRole } = useContext(LoginContext);
  const [loadingExportSelection, setLoadingExportSelection] = useState(false);
  const [loadingExportAll, setLoadingExportAll] = useState(false);

  useEffect(() => {
    !loadingExport && setLoadingExportSelection(false);
    !loadingExport && setLoadingExportAll(false);
  }, [loadingExport]);

  const exportSelection = () => {
    setLoadingExportSelection(true);
    handleExport(notificationId, selectedRows.map((r) => r.userId))
  };

  const exportAll = () => {
    setLoadingExportAll(true);
    handleExport(notificationId);
  };

return  (
  <div className={classes.gridControls}>
      <div className={classes.gridButtonsWrapper}>
        <AnimatedButton
          disabled={selectedRows.isEmpty()}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<FormatListNumberedOutlinedIcon />}
          onClick={() => isAllowedByRole() && exportSelection()}
          loading={loadingExportSelection}>
          Exportar selección
        </AnimatedButton>
        <AnimatedButton
          disabled={rows.isEmpty()}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<ListAltIcon />}
          onClick={() => isAllowedByRole() && exportAll()}
          loading={loadingExportAll}>
          Exportar todo
        </AnimatedButton>
       
      </div>
    </div>
  );
};

const NotificationConformedGrid = ({
  data,
  loading,
  tableRef,
  reloadGrid,
  selectedRows,
  setSelectedRows,
  open,
  setOpen,
  gridActions,
  gridFunctions,
  notificationId
}) => {
  const classes = useStyles();

  const BoldValue = ({ value }) => {
    return (<b>{value}</b>);
  };
  
  const colDefs = useGridColDefs([
    { title: 'userId', field: 'userId', hidden: true },
    { title: 'Proveedor', field: 'supplierName' },
    { title: 'Estado', field: 'status' },
    { title: 'Fecha de aceptación', field: 'conformedDate', valueType: "date" },  

  ]);
  
  return (
    <Fragment>
      
      <div className={classes.root}>
        <div className={classes.gridActions}>
          <GridActions selectedRows={selectedRows} loading={loading} setOpen={setOpen} rows={data} notificationId={notificationId} {...gridActions} />
        </div>
        <MaterialTable
          {...defaultGridOptions}
          options={{
            ...defaultGridOptions.options,
            pageSizeOptions: [...defaultGridOptions.options.pageSizeOptions, defaultGridOptions.options.pageSizeOptions.last() * 2],
            selection: true,
            headerSelectionProps: { color: 'primary'}, 
            selectionProps: rowData => {
              return {
                color: 'primary',
              };
            },
          }}
          onSelectionChange={(rows, row) => setSelectedRows(rows)}
          columns={colDefs}
          data={data}
          isLoading={loading}
          tableRef={tableRef}
        />
      </div>
    </Fragment>
  );
};


export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useNotificationsConformedPresenter = (tableRef, notificationId) => {
 
  const { showError, showWarning } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [sort, setSort] = useState('');
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [status, setStatus] = useState('0');
  const [statusOptions, setStatusOptions] = useState([]);

  useEffect(() => {
    getFilterOptions();
    search();
  }, []);

  useEffect(() => {
    setRowsToShow(rows);
    
  }, [rows]);

  const cleanFilters = () => {

    setStatus('0');
    setSelectedSupplier(null);

  };

  const getFilterOptions = () => {
    console.log('Entra funcion estados filtro')
    notificationsAPI.getStatus()
      .then(res => setStatusOptions(res))
      .catch(error => {
        showError('Error al obtener las opciones del filtro de Estados')
      })
    
  }

  const search = reload => {
    
    const request = reload
      ? oldSearchRequest
      : {
          supplierId: selectedSupplier ? selectedSupplier.id : '',
          status: status == '0' ? '' : status
        };

    setFirstLoad(false);
    setLoading(true);
    setOldSearchRequest(request);

    notificationsAPI.getNotificationConformed(notificationId, request.supplierId, request.status)
      .then(res => {
        console.log("data: ", res)
        setRows(res);
      })
      .catch(error => {
        showError('Error al obtener los registros');
      })
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => search(true);

  
  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;
/*
    if ((errors[i++] = dateFrom && !dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    }

    if ((errors[i++] = !dateFrom && dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    }

    if((errors[i++] = dateFrom && dateTo && dateTo.isBefore(dateFrom))){
      errorMessages.push('La Fecha hasta no puede ser menor a la Fecha desde');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors; */

    return true;
  };

  const validateAndSearch = () => validateFilters() && search();

  const handleExport = (notificationId, supplierIds) => {
    
    setLoadingExport(true);

    const request = {
      notificationId: notificationId ? notificationId : rows.map(r => r.id),
      supplierIds: supplierIds ? supplierIds : rows.map(r => r.userId)
    }

    return notificationsAPI.exportToExcel(request)
      .then(res => decodeFileXLSX(res, `Confirmacion_de_adhesion_${currentDateForFile()}.xlsx`))
      .catch(error => showError('No se pudo descargar el archivo solicitado'))
      .finally(() => setLoadingExport(false));
  };

  return {

    validateAndSearch,
    cleanFilters,
    rows: rowsToShow,
    firstLoad,
    loading,
    selectedSupplier,
    setSelectedSupplier,
    status,
    setStatus,
    statusOptions,
    setStatusOptions,
    gridFunctions: {
      disableSelectAll: 
      reloadGrid,
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      cuit: oldSearchRequest.cuit,
      gridActions: {
        handleExport,
        loadingExport,
        sort,
        setSort,       
      },
    },
  };
};




//const useStyles = makeStyles(theme => ({
//  ...commonFilter,
//}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const {
    validateAndSearch,
    cleanFilters,
    selectedSupplier,
    setSelectedSupplier,
    status,
    setStatus,
    statusOptions,
    setStatusOptions
    
  } = filtersProps;


  return (
    <div className={classes.filters}>
        <SupplierFilter value={selectedSupplier} setValue={setSelectedSupplier} />
      
        <SelectAcerBrag
              
          rows={[{id: '0', name: 'Todos'}, ...statusOptions]}
          value={status}
          setValue={setStatus}
          style={{ marginBottom: 4 }}
          selectTitle="Estado"
          forceMenuPosition={true}
        />
        
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};



const NotificationDetailsConformedDialog = ({ notificationId }) => {
  const tableRef = useRef();
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useNotificationsConformedPresenter(tableRef, notificationId);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <NotificationConformedGrid data={rows} loading={loading} tableRef={tableRef} notificationId={notificationId} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};


export default NotificationDetailsConformedDialog;